import { Component } from '@angular/core';

import { OPTIONAL_COOKIE_SERVICES } from '../../core/privacy/cookie-preferences';
import { CookieConsentService } from '../../core/services/cookie-consent.service';

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss'],
})
export class CookiePolicyComponent {
  readonly optionalServices = OPTIONAL_COOKIE_SERVICES;

  constructor(private readonly cookieConsentService: CookieConsentService) {}

  openCookiePreferences(event: Event): void {
    const opener =
      event.currentTarget instanceof HTMLElement ? event.currentTarget : null;
    this.cookieConsentService.openPreferences(opener);
  }
}
